import { render, staticRenderFns } from "./NoDataComponent.vue?vue&type=template&id=1ff8adf9"
import script from "./NoDataComponent.vue?vue&type=script&lang=js"
export * from "./NoDataComponent.vue?vue&type=script&lang=js"
import style0 from "./NoDataComponent.vue?vue&type=style&index=0&id=1ff8adf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports